import { call, put, takeLatest } from 'redux-saga/effects';

import magentoService from '@services/magento.service';

import { actions } from '@store/actions/aftership/order';
import { Action, ActionType } from '@store/interfaces/aftership/order';

interface AnyResponseInterface {
  [key: string]: any;
}

function* getOrder(payload: Action) {
  try {
    const { id, force } = payload;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    const dataResponse: AnyResponseInterface = yield call(magentoService.fetchAftershipOrder, String(id), force);
    yield put(actions.getOrderSuccess(dataResponse));
  } catch (error: any) {
    console.log(error);
    const message = error?.response?.data?.message || error?.message;
    yield put(actions.getOrderFailure(message));
  }
}
function* orderSaga() {
  yield takeLatest(ActionType.GET_ORDER_REQUEST, getOrder);
}
export default orderSaga;
